<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('animales')">Animales</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Gestaciones
      <span class="text-gray-500 text-base font-normal ml-2">
        ({{ animal.arete }} - {{ animal.nombre }})
      </span>
    </h1>

    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
        </select>
      </search-filter>

      <div class="flex gap-2">
        <inertia-link class="btn-indigo" :href="route('animales.edit', animal.id)">
          <span>Volver</span>
          <span class="hidden md:inline">Animal</span>
        </inertia-link>

        <button class="btn-indigo" type="button" @click="openModal = true">
          <span>Registrar</span>
          <span class="hidden md:inline">Gestación</span>
        </button>
      </div>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Fecha Diagnóstico</th>
          <th class="px-6 pt-6 pb-4">Diagnóstico</th>
          <th class="px-6 pt-6 pb-4">Días</th>
          <th class="px-6 pt-6 pb-4">F. Probable Parto</th>
          <th class="px-6 pt-6 pb-4">Estado</th>
          <th class="px-6 pt-6 pb-4">Observaciones</th>
        </tr>

        <tr v-for="g in gestaciones.data" :key="g.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4">{{ g.fecha_diagnostico || '-' }}</td>
          <td class="border-t px-6 py-4">{{ g.diagnostico || '-' }}</td>
          <td class="border-t px-6 py-4">{{ g.dias_gestacion != null ? g.dias_gestacion : '-' }}</td>
          <td class="border-t px-6 py-4">{{ g.fecha_probable_parto || '-' }}</td>
          <td class="border-t px-6 py-4">{{ g.estado_gestacion || '-' }}</td>
          <td class="border-t px-6 py-4">{{ g.observaciones || '-' }}</td>
        </tr>

        <tr v-if="gestaciones.data.length === 0">
          <td class="border-t px-6 py-4" colspan="6">No hay gestaciones registradas</td>
        </tr>
      </table>
    </div>

    <pagination class="mt-6" :links="gestaciones.links" />

    <!-- MODAL REGISTRAR GESTACIÓN -->
    <div v-if="openModal" class="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60" @click="closeModal"></div>

      <div class="relative bg-white rounded-md shadow-xl overflow-hidden w-full max-w-3xl">
        <div class="px-8 py-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
          <div class="font-bold">Registrar Gestación</div>
          <button type="button" class="text-gray-500 hover:text-gray-800" @click="closeModal">✕</button>
        </div>

        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <select-input
              v-model="gForm.evento_reproductivo_id"
              :error="gForm.errors.evento_reproductivo_id"
              class="pr-6 pb-8 w-full lg:w-2/3"
              label="Evento Reproductivo (opcional)"
            >
              <option :value="null">Seleccione</option>
              <option v-for="e in eventos" :key="e.id" :value="e.id">
                {{ e.fecha_evento }} - {{ e.metodo || '' }} - {{ e.semen_codigo || '' }}
              </option>
            </select-input>

            <select-input
              v-model="gForm.estado_gestacion"
              :error="gForm.errors.estado_gestacion"
              class="pr-6 pb-8 w-full lg:w-1/3"
              label="Estado"
              required
            >
              <option value="EN_GESTACION">EN_GESTACION</option>
              <option value="PARTO">PARTO</option>
              <option value="ABORTO">ABORTO</option>
              <option value="PERDIDA">PERDIDA</option>
              <option value="CANCELADA">CANCELADA</option>
            </select-input>

            <text-input
              v-model="gForm.fecha_diagnostico"
              :error="gForm.errors.fecha_diagnostico"
              class="pr-6 pb-8 w-full lg:w-1/3"
              label="Fecha Diagnóstico"
              type="date"
              required
            />

            <text-input
              v-model="gForm.diagnostico"
              :error="gForm.errors.diagnostico"
              class="pr-6 pb-8 w-full lg:w-2/3"
              label="Diagnóstico"
              placeholder="Ej: PREÑADA"
            />

            <text-input
              v-model="gForm.dias_gestacion"
              :error="gForm.errors.dias_gestacion"
              class="pr-6 pb-8 w-full lg:w-1/3"
              label="Días Gestación"
              type="number"
            />

            <text-input
              v-model="gForm.fecha_probable_parto"
              :error="gForm.errors.fecha_probable_parto"
              class="pr-6 pb-8 w-full lg:w-1/3"
              label="Fecha Probable Parto"
              type="date"
            />

            <text-input
              v-model="gForm.observaciones"
              :error="gForm.errors.observaciones"
              class="pr-6 pb-8 w-full"
              label="Observaciones"
            />
          </div>

          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="gForm.processing" class="btn-indigo" type="submit">
              Guardar Gestación
            </loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Gestaciones' },
  components: {
    Pagination,
    SearchFilter,
    TextInput,
    SelectInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    animal: Object,
    filters: [Object, Array],
    gestaciones: Object,
    eventos: Array,
  },
  data() {
    return {
      openModal: false,
      form: {
        search: this.filters && this.filters.search ? this.filters.search : null,
        trashed: this.filters && this.filters.trashed ? this.filters.trashed : null,
      },
      gForm: this.$inertia.form({
        evento_reproductivo_id: null,
        fecha_diagnostico: null,
        diagnostico: 'PREÑADA',
        dias_gestacion: 283,
        fecha_probable_parto: null,
        estado_gestacion: 'EN_GESTACION',
        observaciones: null,
      }),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(
          this.route('animales.gestaciones', { animal: this.animal.id }),
          pickBy(this.form),
          { preserveState: true }
        )
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    closeModal() {
      this.openModal = false
      this.gForm.clearErrors()
    },
    store() {
      this.gForm.post(this.route('animales.gestaciones.store', { animal: this.animal.id }), {
        preserveScroll: true,
        onSuccess: () => {
          this.openModal = false
          this.gForm.reset()
          this.gForm.diagnostico = 'PREÑADA'
          this.gForm.dias_gestacion = 283
          this.gForm.estado_gestacion = 'EN_GESTACION'
        },
      })
    },
  },
}
</script>